
<template>
    <div class="pane" :class="{ 'is-loading': loading }">
        <template v-if="order">
            <header>
                <h1>Order / {{ order_id }}</h1>
                <router-link :to="{ name: 'admin.orders', query: $route.query }">Back</router-link>
            </header>

            <div class="content" v-html="order"></div>

            <footer>
                <div class="buttons">
                    <router-link :to="{ name: 'admin.orders', query: $route.query }" class="button">Cancel</router-link>
                </div>

                <div class="buttons">

                </div>
            </footer>
        </template>
    </div>
</template>

<script>
    import Order from '../../models/Order';
    import User from '../../models/User';

	export default
    {
        data()
        {
            return {
            	loading: false,
                order: null,
                order_id: this.$route.params.id,
            };
        },
        methods:
        {

        },
        mounted()
        {
        	Order.details( this.$route.params.id ).then( order => {
		        this.order = order;
		        this.loading = false;
	        });
        },
        params:
        {
            id: {
	            default: null,
                type: Number,
            }
        }
	};
</script>
